module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEFSURBVHgB7dixDcIwEIXhZ+NBPIpHYAMoQmgZATagcwQNI7ABMAlhA+gBcwUIicrEkY5D90lRFClFfiWKzgaEMyjQNOsdkAIKOWd9VVUndGAhnPgAh55Yi1DX9SH3/qZZHenkUUg/IW4awE0DuGkANw3gJn8WijF6a90IHaSUPJjRMOc8PcgcQv3bOJ1aY+wGmejNjdHDSFziI8C00+lkgUy0pAyU4cFIf6PcNICbBnDrbVulxPV6H8a4uuBrt/YnAsjSdNrkHOz1E+pH2tIUcM682dMRXhc/EeDcYJa7Ox3jOhjz3hHX3yg3DeCmAdw0gJsGcNMAbuIDzHO620Em+Qsa8QEPMLY2xAR6XNwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar/rank.png
// module id = tR8m
// module chunks = 7